import React from "react";
import "./Gallery.css";

function Gallery() {
  return (
    <div className="life-section">
      <h1 className="life-title">Life at AERLIS GRO</h1>
      <p className="life-subtitle">
A professional environment built on trust, collaboration, and continuous development — where expert consultation, dedicated teamwork, and structured training come together to deliver excellence and drive sustainable growth    </p>

      <div className="life-gallery">
        <div className="life-card">
          <img src="/images/g1.jpeg" alt="Celebration" />
          <h3>Empowering Talent Through Structured Development</h3>
        </div>

        <div className="life-card">
          <img src="/images/g2.jpeg" alt="Trekking" />
          <h3>Welcoming You with Trust and Transparency</h3>
        </div>

        <div className="life-card">
          <img src="/images/g3.jpeg" alt="Trip" />
          <h3>Working with Focus. Delivering with Integrity</h3>
        </div>

        {/* 4th Image automatically goes to next row */}
        <div className="life-card">
          <img src="/images/g4.jpeg" alt="Event" />
          <h3>Providing Professional Consultation and Trusted Guidance</h3>
        </div>

          {/* 5th Image automatically goes to next row */}
        <div className="life-card">
          <img src="/images/g5.jpeg" alt="kl" />
          <h3>Empowering Professionals to Secure Every Life.</h3>
        </div>
      </div>
    </div>
  );
}

export default Gallery;
